import React, { useEffect } from 'react';
import swimmminghero from '../img/img-3.jpg';
import { Link } from 'react-router-dom';
import { FaShoppingCart } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';

const HeroSection = () => {
  useEffect(() => {
    AOS.init({
      once: false,
      mirror: true,
    });
  }, []);

  return (
    <section
      id="home"
      className="relative w-full overflow-hidden mt-[62px] sm:mt-[68px]"
    >
      {/* Background image */}
      <img
        src={swimmminghero}
        alt="Crystal-clear villa swimming pool in Ubud Bali - Pool Shop Surya Jaya Teknik"
        className="absolute inset-0 w-full h-[80vh] md:h-screen object-cover object-center z-[-1]"
      />

      {/* Overlay - subtle gradient so image stays visible but text is readable */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/20 to-black/50 z-[-1]" />

      {/* Text Content */}
      <div className="relative flex flex-col items-center justify-center text-center h-[80vh] md:h-screen px-4">
        <h1 className="uppercase text-white font-bold text-xl sm:text-3xl md:text-5xl font-roboto drop-shadow-[0_2px_8px_rgba(0,0,0,0.8)]">
          Bali’s Trusted Partner for Pool Supply & Maintenance
        </h1>
        <p className="text-white mt-2 text-sm sm:text-lg md:text-2xl font-roboto drop-shadow-[0_1px_6px_rgba(0,0,0,0.7)]">
          Effortless Swimming Pool Care
        </p>

        <Link
          to="/product"
          className="mt-6 md:mt-12 inline-flex items-center bg-primary text-white text-xs sm:text-sm px-4 py-2 md:px-6 md:py-3 rounded hover:bg-primary-dark transition font-semibold uppercase"
        >
          <FaShoppingCart className="mr-2" />
          Our Products
        </Link>
      </div>
    </section>
  );
};

export default HeroSection;
